import { Button, Dialog, FormControl, IconButton, InputAdornment, styled, Switch, SwitchProps, TextField } from "@mui/material"
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import {ProjectConfig} from 'Global';
import { useSnackbar, withSnackbar } from "notistack";
import AutocompleteCities from "elements/AutocompleteCities";
import AutocompleteField from "elements/AutocompleteField";
import AutocompletePlans from "elements/AutocompletePlans";
import ISwitch from "elements/ISwitch";
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { PiEyeLight } from "react-icons/pi";
import { PiEyeSlashLight } from "react-icons/pi";
import AlertDialog from "elements/AlertDialog";

//TODAY DATE FORMATED MM/DD/YYYY
const today = new Date('2014-08-18T21:11:54')


export default function CompanyEditor(props : any) {

  const {
    setLoading,
    openEditor,
    setOpenEditor,
    company_id,
    loadList
  } = props;


  /*SNACKBAR FUNCTION FOR NOTIFICATIONS*/
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  /*============================================= */



  // company_id	company_name	email	nit	address	city_id	manager_name	manager_phone		
  const navigate = useNavigate();
  const defaultValues: any = {
    company_id: company_id? company_id : "null",
    company_name: "",
    email: "",
    nit: "",
    address: "",
    city_id: null,
    location_region_id: "",
    location_city_id: "",
    manager_name: "",
    manager_phone: "",
    plan_id: null,
    master_password: "",
    restrictions: {
      allowOutOfStockSale: false,
      geolocationOrders: false,
      geolocationRoutes: false,
      geolocationRoutesPrecision: 0,
      allowSaleWhenOutOfStock: false,
      advancedOrderEditor: false,
      simplifiedProductList: false,
      max_discount: 0,
      enableGeolocation: false,
    },
    image: "",
    is_active: true,
  };

  
  
  const [formValues, setFormValues] = useState(defaultValues)

  // Show/hide password state
  const [showPassword, setShowPassword] = useState(false);

  // Password validation state
  const [passwordValidation, setPasswordValidation] = useState({
    hasMinLength: false,
    hasUpperCase: false,
    hasLowerCase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });

  // Warehouses state
  const [warehouses, setWarehouses] = useState([]);

  // Initialize warehouse dialog state
  const [openInitDialog, setOpenInitDialog] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<any>(null);
  const [initStock, setInitStock] = useState<number>(0);

  // Alert dialog for confirmation
  const [openAlertDialog, setOpenAlertDialog] = useState(false);

  // Validate password
  const validatePassword = (password: string) => {
    setPasswordValidation({
      hasMinLength: password.length >= 8,
      hasUpperCase: /[A-Z]/.test(password),
      hasLowerCase: /[a-z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const isPasswordValid = () => {
    // If password is empty, it's valid (optional field)
    if (!formValues.master_password || formValues.master_password === "") {
      return true;
    }
    // If password has content, must meet all requirements
    return (
      passwordValidation.hasMinLength &&
      passwordValidation.hasUpperCase &&
      passwordValidation.hasLowerCase &&
      passwordValidation.hasNumber &&
      passwordValidation.hasSpecialChar
    );
  };

  const handleInputChange = (e: { target: { name: any; value: any; }; }) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });

    // Validate password on change
    if (name === "master_password") {
      validatePassword(value);
    }
  };

    const [files, setFiles] = useState<any>([]);


  /*=======================================
  SUBMIT FORM
  =======================================*/
  const handleSubmit = () => {
    // Validate password before submitting
    if (!isPasswordValid()) {
      enqueueSnackbar('La contraseña maestra no cumple con los requisitos de seguridad', { variant: 'error' });
      return;
    }

    setLoading(true)

    const submitValues = {
      ...formValues,
      restrictions: {
        ...formValues.restrictions,
        autoInvoiceOnOrder: formValues.restrictions?.autoInvoiceOnOrder ?? (!formValues.restrictions?.autoInvoiceOnApproval),
      },
    };

    const body = new FormData();
    if (files){
      console.log("filesxxx", files)
      body.append("image", files);
    }
    body.append("formValues", JSON.stringify(submitValues));

    axios.post(ProjectConfig.api_url+"/companies/addedit", body,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log(response.data);

        if(response.data.status === "success"){
          enqueueSnackbar('Administrador guardado con éxito', { variant: 'success' });
          setOpenEditor(false)
          loadList();
        }else{
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
          
      })
      .catch((err) => {
        console.log(err.response.data);
      })
      .finally(() => {
        setLoading(false)
      });
  };



  /*=======================================
  LOAD WAREHOUSES
  =======================================*/
  useEffect(() => {
    if (openEditor && company_id) {
      axios.get(ProjectConfig.api_url + "/warehouses/list", {
        headers: {
          ltkn: localStorage.getItem("ltkn"),
          delegated_company_id: company_id,
        },
        params: {
          full_list: true,
        },
      })
      .then((response) => {
        setWarehouses(response.data.list);
      })
      .catch((err) => {
        console.log(err);
      });
    }
  }, [openEditor, company_id]);

  /*=======================================
  INITIALIZE WAREHOUSE
  =======================================*/
  const handleInitializeWarehouse = () => {
    if (!selectedWarehouse) return;

    setLoading(true);
    axios.post(
      ProjectConfig.api_url + "/products/initializeWarehouseInventory",
      {
        warehouse_id: selectedWarehouse.warehouse_id,
        stock: Number(initStock),
      },
      {
        headers: {
          ltkn: localStorage.getItem("ltkn"),
          delegated_company_id: company_id,
        },
      }
    )
    .then((response) => {
      if (response.data.status === "success") {
        enqueueSnackbar(`Inventario de ${selectedWarehouse.warehouse_name} inicializado correctamente`, { variant: "success" });
        setOpenInitDialog(false);
        setSelectedWarehouse(null);
        setInitStock(0);
      } else {
        enqueueSnackbar(response.data.message, { variant: "error" });
      }
    })
    .catch((err) => {
      console.log(err);
      enqueueSnackbar("Error al inicializar el inventario", { variant: "error" });
    })
    .finally(() => {
      setLoading(false);
    });
  };

  /**/

  useEffect(() => {
    if (company_id) {

      axios.get(ProjectConfig.api_url + "/companies/details", {
          params: {
            company_id: company_id,
          },
        })
        .then((response) => {
          console.log("formValues res", response.data)

          //convert

          // Ensure master_password is never null, convert to empty string
          const dataWithPassword = {
            ...response.data,
            master_password: response.data.master_password || ""
          };

          setFormValues(dataWithPassword)
          // Validate existing password if any
          if (dataWithPassword.master_password) {
            validatePassword(dataWithPassword.master_password);
          } else {
            // Reset validation if no password
            setPasswordValidation({
              hasMinLength: false,
              hasUpperCase: false,
              hasLowerCase: false,
              hasNumber: false,
              hasSpecialChar: false,
            });
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    }
    else{
      setFormValues(defaultValues);
      // Reset validation for new company
      setPasswordValidation({
        hasMinLength: false,
        hasUpperCase: false,
        hasLowerCase: false,
        hasNumber: false,
        hasSpecialChar: false,
      });
    }
    setFiles([]);
  }, [company_id, openEditor]);

  console.log("formValues", formValues)


  return (
      <>
        <Dialog 
          open={openEditor}
          onClose={() => setOpenEditor(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="DialogContainer" style={{maxWidth:'502px'}}>
              <div className="ModuleWrapper">
                  <div className="boxContainerHeader">
                      <div className="boxContainerTitle">
                          <h2 className="h2_title">Empresa</h2>
                          <span className="h2_subtitle">Editar</span>
                      </div>

                      
                  </div>

                  <div id="userForm">
                    <div className="userForm_right">
                        <div className='input_group'>

                        <div className="drawerImagesContainer">
                            
                            <div className="drawerImagesContainerDiv"
                              onDrop={(e) => {
                                  e.preventDefault();
                                  // UPDATE FILE
                                  const files = e.dataTransfer.files;
                                  setFiles(files[0]);
                                  const fileArray = Array.from(files).map((file:any) => URL.createObjectURL(file));
                                  setFormValues({
                                    ...formValues,
                                    image: fileArray[0],
                                  });
                                  e.currentTarget.classList.remove("dropzone_active");
                                }
                                } 
                                onDragOver={
                                  (e) => {
                                    e.preventDefault();
                                    e.currentTarget.classList.add("dropzone_active");
                                  }
                                  
                                }
                                onDragLeave={
                                  (e) => {
                                    e.preventDefault();
                                    e.currentTarget.classList.remove("dropzone_active");
                                  }
                                }
                            
                              >
                              {formValues.image && (
                                <img src={formValues.image}  />
                              )}
                              
                              <label id='dropFileDiv' className={formValues.image && ('showOnlyOnHover')}>
                                <IconButton 
                                  aria-label="delete"
                                  size="small"
                                  className="addFile_button"
                                  component="span"
                                >
                                  <CameraAltIcon/>
                                  <input 
                                    type="file"
                                    multiple 
                                    hidden 
                                    onChange={(e) => {
                                      const files = e.target.files;
                                      if (files) {
                                          
                                          // UPDATE FILE
                                          setFiles(files[0]);
                                          const fileArray = Array.from(files).map((file:any) => URL.createObjectURL(file));
                                          setFormValues({
                                            ...formValues,
                                            image: fileArray[0],
                                          });
    
                                        }
    
                                    }}
                                  />
                                  
                                </IconButton>
                              </label>
                              
                            </div>
    
                          </div>
                          
                            <h2>Información empresa</h2>
                            <div className='input_group'>

                                <div className='input_row'>

                                <TextField 
                                  id="company_name"
                                  name="company_name"
                                  label="Nombre empresa"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.company_name}
                                  onChange={handleInputChange}
                                />
                                

                                <TextField
                                  id="nit"
                                  name="nit"
                                  label="NIT"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.nit}
                                  onChange={handleInputChange}
                              />
                              

                              </div>

                              <TextField
                                  id="email"
                                  name="email"
                                  label="Email"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.email}
                                  onChange={handleInputChange}
                                />

                             
                            </div>

                            <div className='input_group'>
                              <h2>Contraseña Maestra</h2>
                              <TextField
                                id="master_password"
                                name="master_password"
                                label="Contraseña Maestra"
                                type={showPassword ? "text" : "password"}
                                fullWidth
                                autoComplete="new-password"
                                value={formValues.master_password}
                                onChange={handleInputChange}
                                helperText="Opcional - Solo requerida si deseas establecer una contraseña maestra"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <IconButton
                                        onClick={() => setShowPassword(!showPassword)}
                                        edge="end"
                                        size="small"
                                      >
                                        {showPassword ? <PiEyeSlashLight size={20} /> : <PiEyeLight size={20} />}
                                      </IconButton>
                                    </InputAdornment>
                                  ),
                                }}
                              />

                              {/* Password validation indicators */}
                              {formValues.master_password && formValues.master_password.length > 0 && (
                                <div style={{ marginTop: '10px', fontSize: '12px' }}>
                                  <div style={{ color: passwordValidation.hasMinLength ? '#4caf50' : '#999', marginBottom: '4px' }}>
                                    {passwordValidation.hasMinLength ? '✓' : '○'} Mínimo 8 caracteres
                                  </div>
                                  <div style={{ color: passwordValidation.hasUpperCase ? '#4caf50' : '#999', marginBottom: '4px' }}>
                                    {passwordValidation.hasUpperCase ? '✓' : '○'} Al menos una letra mayúscula
                                  </div>
                                  <div style={{ color: passwordValidation.hasLowerCase ? '#4caf50' : '#999', marginBottom: '4px' }}>
                                    {passwordValidation.hasLowerCase ? '✓' : '○'} Al menos una letra minúscula
                                  </div>
                                  <div style={{ color: passwordValidation.hasNumber ? '#4caf50' : '#999', marginBottom: '4px' }}>
                                    {passwordValidation.hasNumber ? '✓' : '○'} Al menos un número
                                  </div>
                                  <div style={{ color: passwordValidation.hasSpecialChar ? '#4caf50' : '#999', marginBottom: '4px' }}>
                                    {passwordValidation.hasSpecialChar ? '✓' : '○'} Al menos un caracter especial (!@#$%^&*(),.?":{}|&lt;&gt;)
                                  </div>
                                </div>
                              )}
                            </div>

                            
                            <div className='input_group'>
                              <h2>Persona de contacto</h2>
                              <div className="input_row">
                                <TextField
                                  id="manager_name"
                                  name="manager_name"
                                  label="Nombre"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.manager_name}
                                  onChange={handleInputChange}
                                />

                                <TextField
                                  id="manager_phone"
                                  name="manager_phone"
                                  label="Teléfono"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.manager_phone}
                                  onChange={handleInputChange}
                                />
                              </div>
                            </div>


                            <div className='input_group'>
                              <h2>Dirección</h2>
                              <div className="input_row">
                                <TextField
                                  id="address"
                                  name="address"
                                  label="Dirección"
                                  type="text"
                                  required
                                  fullWidth
                                  value={formValues.address}
                                  onChange={handleInputChange}
                                />
                              </div>

                              <AutocompleteCities
                                value={formValues.city_id} 
                                onChange={(e: any) => {
                                  setFormValues({
                                    ...formValues,
                                    city_id: e.target.value,
                                  });
                                }} 
                              />

                              <div className="input_row">
                                <AutocompleteField
                                  label="Departamento"
                                  endpoint="/clients/locationRegions"
                                  fullwidth
                                  dynamic
                                  max_results={10}
                                  value={formValues.location_region_id}
                                  onChange={(data: any) => setFormValues({ ...formValues, location_region_id: data?.value || "", location_city_id: "" })}
                                />
                                <AutocompleteField
                                  label="Ciudad (DANE)"
                                  endpoint="/clients/locationCities"
                                  endpoint_params={{ region_id: formValues.location_region_id }}
                                  fullwidth
                                  dynamic
                                  max_results={10}
                                  disabled={!formValues.location_region_id}
                                  value={formValues.location_city_id}
                                  onChange={(data: any) => setFormValues({ ...formValues, location_city_id: data?.value || "" })}
                                />
                              </div>

                              <AutocompletePlans
                                value={formValues.plan_id}
                                onChange={(e: any) => {
                                  setFormValues({
                                    ...formValues,
                                    plan_id: e.target.value,
                                  });
                                }}
                              />

                            </div>

                            

                            <div className='input_group'>
                              <h2>Restricciones</h2>
                              <div className="input_row flex_wrap">
                                {/* restrictions.kilos */}
                                <ISwitch
                                  label="Kilos"
                                  checked={formValues.restrictions?.kilos !== undefined ? formValues.restrictions.kilos : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        kilos: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                {/* restrictions.square_meter */}
                                <ISwitch
                                  label="M2"
                                  checked={formValues.restrictions?.square_meter !== undefined ? formValues.restrictions.square_meter : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        square_meter: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                {/* restrictions.allowOutOfStockSale */}
                                <ISwitch
                                  label="Permitir venta sin stock"
                                  checked={formValues.restrictions?.allowOutOfStockSale !== undefined ? formValues.restrictions.allowOutOfStockSale : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        allowOutOfStockSale: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                {/* Add new advanced order editor switch */}
                                <ISwitch
                                  label="Editor de pedidos avanzado"
                                  checked={formValues.restrictions?.advancedOrderEditor !== undefined ? formValues.restrictions.advancedOrderEditor : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        advancedOrderEditor: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                <ISwitch
                                  label="Lista de productos simplificado"
                                  checked={formValues.restrictions?.simplifiedProductList !== undefined ? formValues.restrictions.simplifiedProductList : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        simplifiedProductList: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                                <ISwitch
                                  label="Mostrar inventario por bodega"
                                  checked={formValues.restrictions?.showWarehouseInventory !== undefined ? formValues.restrictions.showWarehouseInventory : false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        showWarehouseInventory: e.target.checked,
                                      },
                                    });
                                  }}
                                />

                              </div>

                              <h2>Facturación</h2>
                              <div className="input_row flex_wrap">
                                <ISwitch
                                  label="Factura al realizar pedido"
                                  checked={formValues.restrictions?.autoInvoiceOnOrder ?? (!formValues.restrictions?.autoInvoiceOnApproval)}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        autoInvoiceOnOrder: e.target.checked,
                                        autoInvoiceOnApproval: e.target.checked ? false : formValues.restrictions?.autoInvoiceOnApproval,
                                      },
                                    });
                                  }}
                                />

                                <ISwitch
                                  label="Factura al aprobar pedido"
                                  checked={formValues.restrictions?.autoInvoiceOnApproval ?? false}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        autoInvoiceOnApproval: e.target.checked,
                                        autoInvoiceOnOrder: e.target.checked ? false : formValues.restrictions?.autoInvoiceOnOrder,
                                      },
                                    });
                                  }}
                                />

                              </div>
                              
                              {/* Add max_discount field */}
                              <div className="input_row" style={{ marginTop: '15px' }}>
                                <TextField
                                  id="max_discount"
                                  name="max_discount"
                                  label="Descuento máximo (%)"
                                  type="number"
                                  fullWidth
                                  value={formValues.restrictions?.max_discount !== undefined ? formValues.restrictions.max_discount : 0}
                                  onChange={(e) => {
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        max_discount: Number(e.target.value),
                                      },
                                    });
                                  }}
                                  InputProps={{
                                    inputProps: { 
                                      min: 0,
                                      max: 100
                                    }
                                  }}
                                />
                              </div>


                              <div className="input_row">
                                <h2>Geolocalización</h2>
                                <ISwitch
                                  label="Activar Geolocalización"
                                  checked={formValues.restrictions?.enableGeolocation ?? false}
                                  onChange={(e: any) => {
                                    const checked = e.target.checked;
                                    setFormValues({
                                      ...formValues,
                                      restrictions: {
                                        ...formValues.restrictions,
                                        enableGeolocation: checked,
                                        geolocationOrders: checked ? formValues.restrictions.geolocationOrders : false,
                                        geolocationRoutes: checked ? formValues.restrictions.geolocationRoutes : false,
                                        geolocationOrdersPrecision: checked ? formValues.restrictions.geolocationOrdersPrecision : 0,
                                        geolocationRoutesPrecision: checked ? formValues.restrictions.geolocationRoutesPrecision : 0,
                                      },
                                    });
                                  }}
                                />
                              </div>
                              {formValues.restrictions?.enableGeolocation && (
                                <>
                                  <ISwitch
                                    label="Pedidos Geolocalización"
                                    checked={formValues.restrictions?.geolocationOrders !== undefined ? formValues.restrictions.geolocationOrders : false}
                                    onChange={(e: any) => {
                                      const checked = e.target.checked;
                                      setFormValues({
                                        ...formValues,
                                        restrictions: {
                                          ...formValues.restrictions,
                                          geolocationOrders: checked,
                                          geolocationOrdersPrecision: checked ? formValues.restrictions.geolocationOrdersPrecision : 0,
                                        },
                                      });
                                    }}
                                  />
                                  {formValues.restrictions.geolocationOrders && (
                                    <TextField
                                      id="geolocation_orders_precision"
                                      name="geolocation_orders_precision"
                                      label="Precisión Pedidos Geolocalización"
                                      type="number"
                                      required
                                      fullWidth
                                      value={formValues.restrictions.geolocationOrdersPrecision}
                                      onChange={(e) => {
                                        const { value } = e.target;
                                        setFormValues({
                                          ...formValues,
                                          restrictions: {
                                            ...formValues.restrictions,
                                            geolocationOrdersPrecision: value,
                                          },
                                        });
                                      }}
                                    />
                                  )}
                                  
                                  <ISwitch
                                    label="Rutas Geolocalización"
                                    checked={formValues.restrictions?.geolocationRoutes !== undefined ? formValues.restrictions.geolocationRoutes : false}
                                    onChange={(e: any) => {
                                      const checked = e.target.checked;
                                      setFormValues({
                                        ...formValues,
                                        restrictions: {
                                          ...formValues.restrictions,
                                          geolocationRoutes: checked,
                                          geolocationRoutesPrecision: checked ? formValues.restrictions.geolocationRoutesPrecision : 0,
                                        },
                                      });
                                    }}
                                  />
                                  {formValues.restrictions.geolocationRoutes && (
                                    <TextField
                                      id="geolocation_routes_precision"
                                      name="geolocation_routes_precision"
                                      label="Precisión Rutas Geolocalización"
                                      type="number"
                                      required
                                      fullWidth
                                      value={formValues.restrictions.geolocationRoutesPrecision}
                                      onChange={(e) => {
                                        const { value } = e.target;
                                        setFormValues({
                                          ...formValues,
                                          restrictions: {
                                            ...formValues.restrictions,
                                            geolocationRoutesPrecision: value,
                                          },
                                        });
                                      }}
                                    />
                                  )}
                                </>
                              )}
                            </div>

                            {company_id && (
                              <div className='input_group'>
                                <h2>Bodegas - Inicializar Inventario</h2>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                                  {warehouses.map((warehouse: any) => (
                                    <div
                                      key={warehouse.warehouse_id}
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        padding: '10px',
                                        border: '1px solid #e0e0e0',
                                        borderRadius: '4px',
                                      }}
                                    >
                                      <span style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {warehouse.warehouse_name}
                                      </span>
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={() => {
                                          setSelectedWarehouse(warehouse);
                                          setOpenInitDialog(true);
                                        }}
                                      >
                                        Inicializar
                                      </Button>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            )}

                            <div className='input_group'>
                              <h2>Estado</h2>
                              <div className="input_row">
                                <ISwitch
                                  label="Activo"
                                  checked={formValues.is_active}
                                  onChange={(e: any) => {
                                    setFormValues({
                                      ...formValues,
                                      is_active: e.target.checked,
                                    });
                                  }}
                                />
                              </div>

                              </div>


                        </div>
                    </div>
                </div>
              </div>
          </div>

          <div className="dialogButtons">
            <Button
                onClick={() => setOpenEditor(false)}
                variant="outlined"
                className="button_2"
            >
              Cancelar
            </Button>

            <Button onClick={handleSubmit} variant="contained" className="button_1">Guardar</Button>
          </div>
        </Dialog>

        {/* Dialog for initializing warehouse inventory */}
        <Dialog
          open={openInitDialog}
          onClose={() => {
            setOpenInitDialog(false);
            setSelectedWarehouse(null);
            setInitStock(0);
          }}
        >
          <div className="DialogContainer" style={{maxWidth:'400px'}}>
            <div className="ModuleWrapper">
              <div className="boxContainerHeader">
                <div className="boxContainerTitle">
                  <h2 className="h2_title">Inicializar Inventario</h2>
                  <span className="h2_subtitle">
                    {selectedWarehouse?.warehouse_name}
                  </span>
                </div>
              </div>

              <div id="userForm">
                <div className="userForm_right">
                  <div className='input_group'>
                    <p style={{ marginBottom: '15px', color: '#666' }}>
                      Esta acción establecerá el stock de todos los productos de esta bodega al valor indicado.
                    </p>
                    <TextField
                      id="init_stock"
                      name="init_stock"
                      label="Cantidad de Stock"
                      type="number"
                      required
                      fullWidth
                      value={initStock}
                      onChange={(e) => setInitStock(Number(e.target.value))}
                      onFocus={(e) => e.target.select()}
                      InputProps={{
                        inputProps: {
                          min: 0
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="dialogButtons">
            <Button
              onClick={() => {
                setOpenInitDialog(false);
                setSelectedWarehouse(null);
                setInitStock(0);
              }}
              variant="outlined"
              className="button_2"
            >
              Cancelar
            </Button>

            <Button
              onClick={() => setOpenAlertDialog(true)}
              variant="contained"
              className="button_1"
            >
              Confirmar
            </Button>
          </div>
        </Dialog>

        {/* Alert Dialog for confirmation */}
        <AlertDialog
          open={openAlertDialog}
          setOpen={setOpenAlertDialog}
          subtitle={`¿Estás seguro de inicializar el inventario de ${selectedWarehouse?.warehouse_name}? Esta acción establecerá el stock de todos los productos en esta bodega a ${initStock} unidades.`}
          send={handleInitializeWarehouse}
        />
      </>
  );
}
